import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import { namespace } from 'vuex-class';
import Loading from '@/components/Loading.vue';
import VueMarkdown from 'vue-markdown';
const blobsModule = namespace('blobs');
let CreditsPage = class CreditsPage extends Vue {
    created() {
        this.fetchCreditsBlob();
    }
};
__decorate([
    blobsModule.State
], CreditsPage.prototype, "creditsBlob", void 0);
__decorate([
    blobsModule.Action
], CreditsPage.prototype, "fetchCreditsBlob", void 0);
CreditsPage = __decorate([
    Component({
        components: {
            VueMarkdown,
            Loading
        }
    })
], CreditsPage);
export default CreditsPage;
